import React from "react";

const LOGO_FULL = "https://customer-assets.emergentagent.com/job_podlab-inventory/artifacts/snitddya_Footwork%20Logo%20White.png";
const LOGO_MARK = "https://customer-assets.emergentagent.com/job_podlab-inventory/artifacts/d8ba1bta_F%20logo.png";

export const FootworkLogo = ({ className = "h-12", variant = "full", alt = "footwork" }) => (
  <img
    src={variant === "mark" ? LOGO_MARK : LOGO_FULL}
    alt={alt}
    className={className}
    draggable={false}
  />
);

export default FootworkLogo;
